/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import RETAIL from '../BaseComponent/RETAIL'

class EditAssignDriver extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      drivers: [],
      cars: []
    }
  }

  componentDidMount() {
    var planId = sessionStorage.getItem('planId')

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            drivers: response.data.object
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
        console.log(error)
      })

    http
      .get(`car/manage/list`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            cars: response.data.object
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  EditDriver() {
    var carType = document.getElementById('carType').value
    var driver = document.getElementById('driver').value
    var {dispatchId} = this.props.match.params
    let data = {
      dispatchId: dispatchId,
      driverId: driver,
      carId: carType
    }
    http
      .post(`${RETAIL.RETAIL_COMPANY_PLAN_EDIT_DRIVER}`, data, {})
      .then((response) => {
        if (response.data.error == null) {
          message.success('رساننده اختصاص یافته تغییر کرد')
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submit(e) {
    e.preventDefault()
  }

  render() {
    var {personId, carId} = this.props.match.params

    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>رساننده های انتصابی</li>
            <li>ویرایش رساننده انتصاب شده</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ویرایش رساننده</p>
            </div>
            <div className="formComponent">
              <label>رساننده</label>
              <select className="form-control mb-2 mr-sm-2" id="driver">
                {/*<option value=''>رساننده</option>*/}
                {this.state.drivers.map((driver, index) => (
                  <option value={driver.personId} selected={personId == driver.personId ? true : false}>
                    {driver.name}
                  </option>
                ))}
              </select>
              <label>خودرو</label>
              <select className="form-control mb-2 mr-sm-2" id="carType">
                {/*<option value=''>اتومبیل</option>*/}
                {this.state.cars.map((car, index) => (
                  <option value={car.carId} selected={carId == car.carId ? true : false}>
                    {car.name + ' خودروی شماره ' + car.code}
                  </option>
                ))}
              </select>

              <button className="btn btn-primary btn-block" onClick={this.EditDriver.bind(this)}>
                ویرایش رساننده ثبت شده
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default EditAssignDriver
